import { Link } from 'react-router-dom'
import { useContent } from '@/content'
import { cn } from '@/lib/cn'
import { ROUTES } from '@/lib/paths'
import styles from './Logo.module.css'

interface LogoProps {
  /** Mark size in pixels; the wordmark scales with it. */
  size?: number
  /** Hides the wordmark, leaving only the mark. */
  markOnly?: boolean
  className?: string
}

/** The mark plus wordmark, linking home. */
export const Logo = ({ size = 30, markOnly = false, className }: LogoProps) => {
  const { site } = useContent()

  return (
  <Link
    to={ROUTES.home}
    aria-label={`${site.name} — home`}
    className={cn(styles.logo, className)}
  >
    <img
      src={site.mark}
      alt=""
      width={size}
      height={size}
      className={styles.mark}
    />
    {!markOnly && (
      <span className={styles.wordmark} style={{ fontSize: size * 0.6 }}>
        {site.name}
      </span>
    )}
  </Link>
  )
}
